import React from 'react'
import { Input, Card, Button } from 'antd'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons'
import { useFormikContext, FieldArray } from 'formik'
import { FormField, ArrayItemCard, RemoveButton } from './shared'
import { useFieldPath } from './TabContext'
import { get } from 'lodash'

const { TextArea } = Input

export const AboutCertificationSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  const subtitlePath = useFieldPath('sections.aboutCertification.subtitle')
  const targetAudiencePath = useFieldPath('sections.aboutCertification.targetAudience')

  const targetAudience = get(values, targetAudiencePath, [])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFieldValue(e.target.name, e.target.value)
  }

  return (
    <Card>
      <FormField>
        <label>Subtítulo</label>
        <TextArea
          name={subtitlePath}
          value={get(values, subtitlePath, '')}
          onChange={handleChange}
          rows={2}
          placeholder="Subtítulo da seção"
        />
      </FormField>

      <h4>Público-Alvo</h4>
      <FieldArray name={targetAudiencePath}>
        {(arrayHelpers) => (
          <>
            {targetAudience.map((item, index) => (
              <ArrayItemCard key={index}>
                <RemoveButton>
                  <Button
                    type="text"
                    danger
                    size="small"
                    icon={<DeleteOutlined />}
                    onClick={() => arrayHelpers.remove(index)}
                  />
                </RemoveButton>
                <FormField>
                  <label>Título</label>
                  <Input
                    name={`${targetAudiencePath}.${index}.title`}
                    value={item.title}
                    onChange={handleChange}
                    placeholder="Ex: Motoristas profissionais"
                  />
                </FormField>
                <FormField>
                  <label>Descrição</label>
                  <TextArea
                    name={`${targetAudiencePath}.${index}.description`}
                    value={item.description}
                    onChange={handleChange}
                    rows={2}
                    placeholder="Descrição do público-alvo"
                  />
                </FormField>
              </ArrayItemCard>
            ))}
            <Button
              type="dashed"
              onClick={() => arrayHelpers.push({ title: '', description: '' })}
              block
              icon={<PlusOutlined />}
            >
              Adicionar Público-Alvo
            </Button>
          </>
        )}
      </FieldArray>
    </Card>
  )
}
